import { motion } from "framer-motion";
import { Target, Compass, HeartHandshake } from "lucide-react";
import Seo from "@/components/Seo";
import { Kicker } from "@/components/form";

const fade = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true }, transition: { duration: 0.6 } };
const IMG = "https://static.prod-images.emergentagent.com/jobs/9cdaf805-ebb2-4698-b869-6dae56934adb/images/5b6f9b91bc5645b0c16f06cb1959d6860cc061b8c847520ee95800f15ca87eb4.png";

export default function UeberUns() {
  return (
    <div data-testid="ueber-uns-page">
      <Seo title="Über uns" description="Lernen Sie VM-FFM.DE kennen – Ihr unabhängiger Makler für Versicherung, Finanzierung und Immobilien." path="/ueber-uns" />
      <section className="pt-40 pb-20 bg-navy-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div {...fade} className="max-w-3xl">
            <Kicker>Über uns</Kicker>
            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-white leading-none">Ein Partner, dem Sie vertrauen.</h1>
            <p className="mt-6 text-lg text-gold-500 font-semibold">Sorglos und sicher in Ihre Zukunft.</p>
            <p className="mt-6 text-lg text-slate-300 leading-relaxed">VM-FFM.DE steht für unabhängige, ganzheitliche Beratung im Rhein-Main-Gebiet. Wir verbinden die Kompetenzfelder Versicherung, Finanzierung und Immobilien – damit alle Entscheidungen zu Ihrem Vermögen ineinandergreifen.</p>
            <p className="mt-4 text-base text-slate-400 leading-relaxed">Als unabhängiger Versicherungsmakler in Frankfurt am Main sind wir frei in der Auswahl der Gesellschaften. Wir empfehlen objektiv den Schutz, der Ihre Anforderungen bestmöglich erfüllt, erklären Ihnen Vor- und Nachteile transparent und zeigen verschiedene Preis-Leistungs-Verhältnisse auf. Als Ihr Versicherungsexperte begleiten wir Sie langfristig.</p>
          </motion.div>
        </div>
      </section>
      <section className="bg-offwhite py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.img {...fade} src={IMG} alt="Team" className="rounded-md w-full object-cover aspect-[4/3]" />
          <motion.div {...fade} className="space-y-8">
            {[
              { icon: Compass, t: "Unsere Mission", d: "Komplexe Finanzthemen verständlich machen und Ihnen Entscheidungen mit gutem Gewissen ermöglichen." },
              { icon: Target, t: "Unser Anspruch", d: "Maßgeschneiderte Lösungen statt Standardprodukte – konsequent an Ihren Zielen ausgerichtet." },
              { icon: HeartHandshake, t: "Unsere Werte", d: "Transparenz, Unabhängigkeit und eine partnerschaftliche Beziehung auf Augenhöhe." },
            ].map((v) => (
              <div key={v.t} className="flex gap-4">
                <div className="w-12 h-12 rounded-sm bg-navy-900 flex items-center justify-center shrink-0"><v.icon size={22} className="text-gold-500" /></div>
                <div><h3 className="font-bold text-navy-900 text-xl">{v.t}</h3><p className="text-slate-600 mt-2 leading-relaxed">{v.d}</p></div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>
      <section className="bg-navy-900 py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {[["20+", "Jahre Erfahrung"], ["400+", "Bankpartner"], ["2.500+", "Betreute Mandate"], ["98%", "Weiterempfehlung"]].map(([n, l]) => (
            <div key={l}><p className="font-serif text-4xl lg:text-5xl text-gold-500">{n}</p><p className="text-sm text-slate-400 mt-2">{l}</p></div>
          ))}
        </div>
      </section>
    </div>
  );
}
